import { API_V1 } from '../config'
import { apiFetch } from './api'

export type FeedbackType = 'bug' | 'feature' | 'question' | 'other'

export interface SubmitFeedbackInput {
  type: FeedbackType
  message: string
  contactEmail?: string
  url?: string
  appVersion?: string
  screenshot?: File
}

export interface SubmitFeedbackResult {
  success: boolean
  id?: number
  error?: string
}

export async function submitFeedback(input: SubmitFeedbackInput): Promise<SubmitFeedbackResult> {
  try {
    const form = new FormData()
    form.append('type', input.type)
    form.append('message', input.message)
    if (input.contactEmail) form.append('contact_email', input.contactEmail)
    if (input.url) form.append('url', input.url)
    if (input.screenshot) form.append('screenshot', input.screenshot)

    const headers: Record<string, string> = {}
    if (input.appVersion) headers['X-App-Version'] = input.appVersion

    const response = await apiFetch(`${API_V1}/feedback/`, {
      method: 'POST',
      headers,
      body: form,
    })

    const data = await response.json().catch(() => ({}))

    if (!response.ok) {
      return {
        success: false,
        error: data.error || data.detail || `Feedback failed (${response.status})`,
      }
    }

    return { success: true, id: data.id }
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Network error'
    return { success: false, error: message }
  }
}
